<template>
  <div>
    <div class="card">
      <div class="card-content">
        <div class="card-body">
          <h5 class="card-title">{{$t('Basic details')}}</h5>
          <ul class="list-unstyled">
            <li v-if="user.name">
              <em class="cursor-pointer bx bx-user mb-1 mr-50"></em>{{ user.name }}
            </li>
            <li v-if="user.currentCountry">
              <em class="cursor-pointer bx bx-map mb-1 mr-50"></em><span v-if="user.address && user.address.city">{{ user.address.city }}, </span><span>{{ countryName(user.currentCountry) }}</span>
            </li>
            <li v-if="user.dob">
                <em class="cursor-pointer bx bx-calendar mb-1 mr-50"></em>{{ user.dob.split('T')[0] }}
            </li>
            <li v-if="user.phoneNumber">
                <a @click="onClickTel(user.phoneNumber)">
                    <em class="cursor-pointer bx bx-phone-call mb-1 mr-50"></em>{{ user.phoneNumber }}
                </a>
            </li>
            <li v-if="user.email">
                <a @click="onClickEmail(user.email)">
                    <em class="cursor-pointer bx bx-envelope mb-1 mr-50"></em>{{ user.email }}
                </a>
            </li>
          </ul>
          <div class="row">
            <div class="col-6">
              <h6><small class="text-muted">{{$t('Status')}}</small></h6>
              <p class="capitalize">{{ user.status }}</p>
            </div>
            <div class="col-6">
              <h6><small class="text-muted">{{$t('Gender')}}</small></h6>
              <p class="capitalize">{{ user.gender }}</p>
            </div>
            <div class="col-12" v-if="user.documents && user.documents.length">
              <h6><small class="text-muted">{{$t('Documents')}}</small></h6>
              <div class="row">
                <div v-for="(image, index) in user.documents" :key="index" class="col-md-4 col-sm-12 mt-1">
                    <a @click="onImageClick(index)">
                        <img :src="image" alt="Document" class="w-100">
                    </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from '@/app-assets/js/get-countries.js'
export default {
  props: ["user"],

  data() {
    return {};
  },

  methods: {
    onImageClick(imageIndex){
      window.open(this.user.documents[imageIndex],'_blank')
    },
    onClickTel(phoneNumber){
      window.open(`tel:${phoneNumber}`)
    },
    onClickEmail(email){
      window.open(`mailto:${email}`) 
    },
    countryName(element){
        if(element){
            return getCountryName(element.toUpperCase())
        }
    }
  },

  mounted() {
    console.log(this.user);
  },
};
</script>
<style scoped>
  a:not([href]):not([tabindex]) {
      color: #5A8DEE;
      text-decoration: none;
      cursor: pointer;
  }
  a:not([href]):not([tabindex]):hover{
    color: #175ee4;
  }
</style>